export default __webpack_public_path__ + "static/media/yura6p.6a99a65d.png";